<template>
  <van-swipe
    class="my-swipe"
    :autoplay="3000"
    indicator-color="white"
  >
    <van-swipe-item v-for="(item, index) in images" :key="index">
      <img :src="item" alt="">
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  name: "SWIPER1",

  props: {
    data: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    images() {
      return this.data.split(",")
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
